const actions = {
    page_title: 'Actions',
    title: 'Actions',
    subtitle: 'Запускайте пользовательский код в определённых точках процесса аутентификации, чтобы расширить поведение Logto.',
    status: {
        not_configured: 'Не настроено',
        configured: 'Настроено',
        enabled: 'Включено',
        disabled: 'Отключено',
    },
    types: {
        post_first_factor_verification: {
            name: 'После проверки первого фактора',
            description: 'Запускайте пользовательскую логику после сбоя проверки локального пароля во время входа.',
        },
        post_sign_in: {
            name: 'После входа',
            description: 'Запускайте пользовательскую логику после успешного входа пользователя.',
        },
    },
    data_source_tab: 'Источник данных',
    test_tab: 'Тестовый контекст',
    settings_tab: 'Настройки',
    event_data: {
        title: 'Полезная нагрузка события',
        subtitle: 'Используйте входной параметр `event` для данных события аутентификации.',
    },
    result_data: {
        title: 'Результат действия',
        subtitle: 'Верните объект результата, который Logto понимает для этого типа действия.',
    },
    environment_variables: {
        title: 'Задать переменные окружения',
        subtitle: 'Используйте переменные окружения для хранения конфиденциальной информации.',
        input_field_title: 'Добавить переменные окружения',
        sample_code: 'Доступ к переменным окружения в обработчике действия. Пример:',
    },
    fetch_external_data: {
        title: 'Получить внешние данные',
        subtitle: 'Вызывайте внешние API из скрипта действия.',
        description: 'Используйте функцию `fetch`, чтобы вызывать внешние API и включать данные в результат действия. Пример:',
    },
    settings: {
        title: 'Настройки',
        subtitle: 'Управляйте активностью действия и обработкой ошибок во время выполнения.',
        enabled: {
            title: 'Включить действие',
            description: 'Запускать этот скрипт при срабатывании события аутентификации.',
        },
        on_execution_error: {
            title: 'При ошибке скрипта',
            description: 'Выберите, как Logto должен вести себя, если скрипт завершится с ошибкой во время выполнения.',
            block: 'Блокировать процесс аутентификации',
            allow: 'Разрешить продолжение процесса аутентификации',
            post_first_factor_description: 'Если этот скрипт завершается с ошибкой, Logto всегда отклоняет недействительные учетные данные, чтобы нельзя было обойти проверку пароля.',
        },
    },
    test_context: {
        subtitle: 'Настройте mock-полезную нагрузку события, используемую при запуске тестов.',
        input_field_title: 'Пример JSON события',
    },
    script: {
        title: 'Скрипт',
        restore: 'Восстановить значения по умолчанию',
        restored: 'Восстановлено',
    },
    tester: {
        run_button: 'Запустить тест',
        result_title: 'Результат теста',
    },
    form_error: {
        invalid_json: 'Недопустимый формат JSON',
    },
    security_warning: {
        title: 'Предупреждение безопасности',
        description: 'Это действие выполняется только после сбоя проверки локального пароля. Возвращайте `passwordVerified: true` только после независимой проверки отправленного пароля. Пользователи, созданные этим действием, обходят ограничения, действующие только при регистрации, включая блок-лист email, домен только для SSO, режим с отключённой регистрацией и проверки обязательного профиля при регистрации. Запись профиля и пароля существующих пользователей также происходит до завершения MFA.',
    },
    delete_modal_title: 'Удалить действие',
    delete_modal_content: 'Вы уверены, что хотите удалить это действие? Процесс аутентификации больше не будет запускать этот скрипт.',
    deleted: 'Действие удалено',
    created: 'Действие создано',
    saved: 'Действие сохранено',
};
export default Object.freeze(actions);
